import * as React from 'react';

import { createStyles, Theme, withStyles, WithStyles } from '@material-ui/core';
import classnames from 'classnames';

import MuiButtonGroup, { MuiButtonGroupProps } from './MuiButtonGroup';

const styles = ({ spacing: { unit } }: Theme) =>
  createStyles({
    disablePadding: {
      '& button': {
        paddingLeft: unit + 2,
        paddingRight: unit + 2,
      },
      '& button:not(:first-child)': {
        paddingLeft: 0,
        paddingRight: 0,
        minWidth: 26,
      },
    },
  });

export interface ButtonGroupProps extends Omit<MuiButtonGroupProps, 'classes'>, WithStyles<typeof styles> {
  disablePadding?: boolean;
}

const ButtonGroup: React.FC<ButtonGroupProps> = ({ classes, disablePadding, ...rest }) => (
  <MuiButtonGroup className={classnames({ [classes.disablePadding]: disablePadding })} {...rest} />
);

export default withStyles(styles, { name: 'LumaButtonGroup' })(ButtonGroup);
